import { styled } from '@acko-tech/building-blocks.ui.common';

export const Wrapper = styled.div`
    display: flex;
    position: relative;
    flex-direction: column;
    padding: 20px;
    height: 100vh;
    max-width: 400px;
    margin: 0 auto;
    @media screen and (max-width: 769px) {
        max-width: 700px;
        margin: 0;
    }
`;

export const Header = styled.div`
    display: flex;
`;

export const BackArrowIcon = styled.div`
    display: flex;
    cursor: pointer;
`;

export const AddSubDealerFlex = styled.div`
    display: flex;
    margin-top: 26px;
`;

export const IconFlex = styled.div`
    display: flex;
    cursor: pointer;
`;

export const AddSubDealer = styled.div`
    display: flex;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #040222;
    margin-left: 8px;
    align-items: center;
    cursor: pointer;
`;

export const SubDealerDetails = styled.div`
    display: flex;
    margin-top: 24px;
`;

export const AddRemoveDealerText = styled.div`
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    display: flex;
    color: #040222;
    margin-top: 20px;
`;
